import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Title from '../shared/Title';
import TeamRateStats from './TeamRateStats';
import TeamCountingStats from './TeamCountingStats';
import PlayerTotalsStats from './PlayerTotalsStats';
import PlayerPerGameStats from './PlayerPerGameStats';
import PlayerPer36MinutesStats from './PlayerPer36MinutesStats';
import PlayerRatesStats from './PlayerRatesStats';
import Spinner from '../shared/Spinner';
import { MultiSelect } from '../shared/MultiSelect';
import { createOverflow } from '../../lib/format';
import ItemSelector from '../shared/ItemSelector';

const AdvancedStats = ({
  team,
  pathTo,
  stats,
  onStageChange,
  games,
  onGameChange,
  season,
  playerSort,
  playerSortOptions,
  onPlayerSort,
  activeTabIndex,
  onTabChange,
  division,
  conference,
  isNBA,
}) => {
  const overflow = createOverflow(team, season);

  return (
    <div className="s-advanced-stats">
      <Title
        team={team}
        linkTo={pathTo('team')}
        subtitle={'Advanced Stats'}
        overflow={overflow}
      />

      <div className="filter">
        <div className="form-row">
          <div className="form-column--xs">
            <Select
              options={
                stats &&
                stats.stages.map(mapped => ({
                  value: mapped.id,
                  label: mapped.name ? mapped.name : 'All Stages',
                }))
              }
              onChange={onStageChange}
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Stage selection..."
              isLoading={!stats || !stats.stages}
              isSearchable={false}
            />
          </div>
          <div className="form-column--xs">
            <Select
              options={playerSortOptions}
              onChange={onPlayerSort}
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Sort by..."
              isLoading={!stats}
              isSearchable={false}
              value={playerSort}
            />
          </div>
          <div className="form-column--xs">
            <div className="form-group">
              <label>Division</label>
              <ItemSelector {...division} disabled={isNBA} />
            </div>
          </div>
          <div className="form-column--xs">
            <div className="form-group">
              <label>Conference</label>
              <ItemSelector {...conference} />
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-column--xs">
            <MultiSelect
              className="s-advanced-stats__multi-game-selector"
              empty="Select game(s) to filter by..."
              items={
                games &&
                games.map(mapped => ({ value: mapped.id, label: mapped.name }))
              }
              onChange={onGameChange}
              isSearchable={true}
              isLoading={!games}
              wrapperClassname={
                's-advanced-stats__multi-game-selector--wrapper'
              }
              loadingMessage={'Loading games...'}
              classNamePrefix="react-select"
            />
          </div>
        </div>
      </div>

      {stats ? (
        <div>
          <Tabs defaultIndex={activeTabIndex} onSelect={onTabChange}>
            <TabList className="nav-pills">
              <Tab className="nav-pills__item">Team Rate</Tab>
              <Tab className="nav-pills__item">Team Counting</Tab>
              <Tab className="nav-pills__item">Player Totals</Tab>
              <Tab className="nav-pills__item">Player Per Game</Tab>
              <Tab className="nav-pills__item">Player Per 36 Minutes</Tab>
              <Tab className="nav-pills__item">Player Rates</Tab>
            </TabList>

            <TabPanel>
              <TeamRateStats stats={stats} />
            </TabPanel>
            <TabPanel>
              <TeamCountingStats stats={stats} />
            </TabPanel>
            <TabPanel>
              <PlayerTotalsStats stats={stats} />
            </TabPanel>
            <TabPanel>
              <PlayerPerGameStats stats={stats} />
            </TabPanel>
            <TabPanel>
              <PlayerPer36MinutesStats stats={stats} />
            </TabPanel>
            <TabPanel>
              <PlayerRatesStats stats={stats} />
            </TabPanel>
          </Tabs>
        </div>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

AdvancedStats.propTypes = {
  team: PropTypes.object,
  stats: PropTypes.object,
};

export default AdvancedStats;
